<ion-item-divider [style.bottom]="bottomOffset" [style.position]="'fixed'" [ngClass]="config.class" padding-end
  padding-start class="padding-end padding-start ion-padding-end ion-padding-start">

  <ion-footer>
    <ion-toolbar>

      <div class="social-links">

        <!-- FACEBOOK & TWITTER -->
        <a [href]="facebookShareUrl" target="_blank" data-gated="false" class="icon-facebook">
          <ion-icon name="logo-facebook" size="large">
          </ion-icon>
        </a>

        <!-- PINTEREST -->
        <a [href]="pinterestShareUrl" target="_blank" data-gated="false" data-pin-custom="true" class="icon-pinterest">
          <ion-icon name="logo-pinterest" size="large">
          </ion-icon>
        </a>

        <a [href]="twitterShareUrl" target="_blank" data-gated="false" class="icon-twitter">
          <ion-icon name="logo-twitter" size="large">
          </ion-icon>
        </a>


      </div>


    </ion-toolbar>
  </ion-footer>

</ion-item-divider>